import { scoreColor } from '../../shared/designTokens.js';

/**
 * Horizontal fill bar used inside category rows. Width maps 0–100 score.
 * Color tracks the same scoreColor() used by PDF + ring.
 */
export function ScoreBar({ score, width = 180 }) {
  const clamped = Math.max(0, Math.min(100, Number(score) || 0));
  return (
    <div className="bar-track" style={{ width }} role="presentation">
      <div
        className="bar-fill"
        style={{ width: `${clamped}%`, background: scoreColor(clamped) }}
      />
    </div>
  );
}
